
import { useNavigate } from 'react-router-dom';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import styles from './misc.module.scss';

export default function Impressum() {

    //const dispatch = useDispatch<AppDispatch>();
    //const { t } = useTranslation();
    //const auth = useSelector((state: RootState) => state.authSlice.auth);
    const navigate = useNavigate();

    return (
        <>
            <div style={{ minHeight: "100vh", margin: "0", display: "flex", flexDirection: "column" }}>
                <div className={styles.bwrapper}>
                    <div className="container">

                        {/*auth.isAuthCheckFinished === false &&
                        <><div>Lädt...</div></>
                    */}

                        <LandingpageHeader />

                        <div>

                            <button className="btn btn-dark" onClick={() => { navigate("/") }}><i className="bi bi-house"></i></button>

                            <div style={{ marginTop: "5em" }}>
                                <h3 style={{ textAlign: "center" }}>Impressum</h3>
                            </div>

                            <br />Mario Bergamotti
                            <br />
                            <br />Kontakt:
                            <br />E-Mail: bergamotti@gmail.com
                            <br />Internet: https://www.bergamotti.de
                        </div >


                    </div >
                </div>
                <Footer />
            </div >
        </>
    );
}
